import React from "react";

interface LogoProps {
  className?: string;
}

export const IQDoctorLogo: React.FC<LogoProps> = ({ className = "w-12 h-12" }) => {
  return (
    <img
      src="/logo.png"
      alt="Dr. Watheq Al-Chalabi Clinic Logo"
      className={`${className} object-cover rounded-full select-none max-w-full max-h-full`}
      referrerPolicy="no-referrer"
    />
  );
};
